"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseManagerClient = void 0;
const common_types_1 = require("@cfc/common-types");
const GetCourseTree_1 = require("./commands/GetCourseTree");
class CourseManagerClient {
    constructor(config) {
        this.config = config;
        if (!config.apiKey && !config.authToken) {
            throw new Error('CourseManagerClientConfig must contain an apiKey or authToken');
        }
        if (!config.environment && !config.customEndpoint) {
            throw new Error('CourseManagerClientConfig must have either contain an environment or a customEndpoint');
        }
    }
    getEndpoint() {
        if (this.config.customEndpoint) {
            return this.config.customEndpoint;
        }
        switch (this.config.environment) {
            case common_types_1.CfcEnvironment.PROD:
                return 'https://course.secondstep.org';
            default:
                return `https://course-${this.config.environment}.cfctest.org`;
        }
    }
    getCourseTree(input) {
        return __awaiter(this, void 0, void 0, function* () {
            const commandInput = input;
            if (this.config.apiKey) {
                commandInput.apiKey = this.config.apiKey;
            }
            if (this.config.authToken) {
                commandInput.authToken = this.config.authToken;
            }
            const command = new GetCourseTree_1.GetCourseTreeCommand(this.getEndpoint(), commandInput);
            return yield command.execute();
        });
    }
}
exports.CourseManagerClient = CourseManagerClient;
